export default "__VITE_ASSET__BV$er8ZK__"